<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="u-window record-modal">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-record"></div>
                    <div class="record-view">
                        <div class="table-header flex-between-center">
                            <div class="table-item" style="width: 80px;">序号</div>
                            <div class="table-item" style="width: 230px;">道具</div>
                            <div class="table-item" style="width: 220px;">获得时间</div>
                        </div>

                        <div class="data-view" v-if="list.length">                            
                            <vuescroll>
                                <div class="data-table">
                                    <div class="table-item flex-between-center" v-for="(item,index) in list" :key="index">
                                        <div class="tr-item" style="width: 80px;">{{ index + 1 }}</div>                                   
                                        <div class="tr-item" style="width: 230px;">{{ item.giftName }} * {{ item.sendNum }}</div>
                                        <div class="tr-item" style="width: 220px;">{{ item.createTime }}</div>
                                    </div>
                                </div>
                            </vuescroll>                            
                        </div>
                    </div>
                    
                    <div class="u-btn ok" @click="closeModal"></div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>

.record-modal{
    position: relative;
    width: 690px;
    height: 633px;
    background-image: url(~@/assets/images/modal/bg-modal-record.png);     
}

.t-record{
    width: 506px;
    height: 49px;
    margin: 0 auto 15px;
    font-weight: 400;
    font-size: 0;
    color: transparent;
    text-align: center;    
    background-image: url(~@/assets/images/modal/title-record.png);  
}

.record-view{
    margin: 0 auto;
    padding: 0 30px;
}


.table-header{
    width: 590px;
    height: 50px;
    line-height: 50px;
    margin-left: 20px;
    background-color: #531511;
    font-size: 24px;
    color: #ffac87;
    text-align: center;
    font-family: 'HYJinKaiJ';
}

.data-view{
    height: 350px;
}

.data-table{
    width: 590px;
    margin-left: 20px;
    font-size: 22px;
    color: #ffd7c5;
    text-align: center;

    .table-item{     
        margin: 0 auto 3px;
        padding: 5px 0;
        box-sizing: border-box;
        width: 100%;
        background-color: #571511;
    }

    .tr-item{
        // padding: 0 24px;
    }

    .pet-name{
        width: 180px;
        text-align: center;
    }
}

.u-btn.ok{
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    width: 254px;
    height: 83px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/modal/btn-ok.png); 
}

</style>

<script>
export default {
    data () {
        return {
            visible : false,
            list : [],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },            
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>